import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./News.module.css";

import ImageExample from "./asset/example-image.png";
import ImageLogoExample from "./asset/example-logo.png";
import { syncNews } from "../../../../actions/news";

// import IconTimeSun from "./asset/icon-time-sun.png";
// import IconTimeSunCloud from "./asset/icon-time-sun-cloud.png";
// import IconTimeCloud from "./asset/icon-time-cloud.png";
// import IconTimeRain from "./asset/icon-time-rain.png";

// import { ReactComponent as IconArrowBold } from "./asset/icon-arrow-bold.svg";
// import { ReactComponent as IconArrowDown } from "./asset/icon-arrow-down.svg";
// import { ReactComponent as IconArrowUp } from "./asset/icon-arrow-up.svg";
// import { ReactComponent as IconArrowGreen } from "./asset/icon-arrow-green.svg";
// import { ReactComponent as IconArrowSmall } from "./asset/icon-arrow-small.svg";
import { ReactComponent as IconMagic } from "./asset/icon-magic.svg";
// import { ReactComponent as IconPlus } from "./asset/icon-plus.svg";
import { ReactComponent as IconSearch } from "./asset/icon-search.svg";
// import { ReactComponent as IconSettings } from "./asset/icon-settings.svg";


const PopUpNews = ({ }) => {


  // const [links, setLinks] = useState([
  //   "Noticias destacadas",
  //   "Seleccionadas para ti",
  // ]);
  const dispatch = useDispatch();

  // Estados para la funcionalidad de búsqueda
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filters, setFilters] = useState([
    "Para ti",
    "Noticias destacadas"
  ]);

  // Funciones para manejar la búsqueda
  const handleSearchClick = () => {
    setShowSearchInput(!showSearchInput);
    if (!showSearchInput) {
      setSearchValue("");
    }
  };

  const handleSearchInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchValue.trim() && !filters.includes(searchValue.trim())) {
      setFilters([...filters, searchValue.trim()]);
      setSearchValue("");
      setShowSearchInput(false);
    }
  };

  const handleRemoveFilter = (filterToRemove) => {
    // No permitir eliminar los filtros base
    if (filterToRemove === "Para ti" || filterToRemove === "Noticias destacadas") {
      return;
    }
    setFilters(filters.filter(filter => filter !== filterToRemove));
  };


  const fallbackNews = [
    {
      href: "/noticias-destacadas",
      title: "Diario de Noticias de Navarra",
      description: "Confirmada la identidad del hombre muerto en San Juan de forma violenta",
      time: "Hace 5 horas",
      image: ImageExample,
    },
    {
      href: "/noticias-destacadas",
      title: "El Comercio",
      description: "Noticias destacadas del día en tu ciudad",
      time: "Hace 3 horas",
      image: ImageExample,
    },
    {
      href: "/noticias-destacadas",
      title: "La República",
      description: "Reportan situación de emergencia en distintas regiones",
      time: "Hace 2 horas",
      image: ImageExample,
    },
    {
      href: "/noticias-destacadas",
      title: "La República",
      description: "Noticias destacadas del día en tu región",
      time: "Hace 4 horas",
      image: ImageExample,
    },
  ];


  const [news, setNews] = useState([]);


  useEffect(() => {
    const getNews = async () => {
      try {
        const res = await dispatch(syncNews());
        if (res.payload && res.payload.data?.length > 0) {
          setNews(res.payload.data.slice(0, 20));
        } else {
          setNews(fallbackNews);
        }
      } catch (error) {
        console.error("Error getting news:", error);
        setNews(fallbackNews);
      }
    };
    getNews();
    // const theme = localStorage.getItem("theme");
    // dispatch(setTheme(theme || "light"));
  }, []);

  // const [weathers, setWeathers] = useState([
  //     {
  //         day: "Hoy",
  //         temperatureMin: "8º",
  //         temperatureMax: "15º",
  //         type: "sun",
  //     }, {
  //         day: "Hoy",
  //         temperatureMin: "8º",
  //         temperatureMax: "15º",
  //         type: "sun-cloud",
  //     }, {
  //         day: "Hoy",
  //         temperatureMin: "8º",
  //         temperatureMax: "15º",
  //         type: "cloud",
  //     }, {
  //         day: "Hoy",
  //         temperatureMin: "8º",
  //         temperatureMax: "15º",
  //         type: "rain",
  //     },

  // ]);


  const [spots, setSpots] = useState([
    {
      type: "spot",
      name: "Spotify",
      price: "60,80",
      variation: "-0,10%",
    }, {
      type: "spot",
      name: "Google",
      price: "100,20",
      variation: "+0,20%",
    }, {
      type: "spot",
      name: "Apple",
      price: "10,45",
      variation: "+10,15%",
    }, {
      type: "spot",
      name: "Microsoft",
      price: "40,45",
      variation: "-5,10%",
    }, {
      type: "spot",
      name: "Spotify",
      price: "60,80",
      variation: "-0,10%",
    }, {
      type: "spot",
      name: "Google",
      price: "100,20",
      variation: "+0,20%",
    }
  ])

  // const noticiasParaMostrar = Array.isArray(noticia) && noticia.length > 0 ? noticia : fallbackNews;

  // const noticiaDestacada = noticiasParaMostrar[0];

  return (
    <div className={styles.popUpNewsContainer}>
      <div className={styles.popUpNewsContainerHeader}>
        <div
          className={styles.popUpNewsHeaderBanner}
          style={{ backgroundImage: `url(${news[0]?.image})` }}
        >
          <div className={styles.bannerOverlay}></div>

          <div className={styles.headerText}>
            <b>Tu resumen</b>
            <span>{new Date().toLocaleDateString("es-ES", { weekday: 'long', day: 'numeric', month: 'long' })}</span>
          </div>
          <div className={styles.magicIconOverlay}>
            <IconMagic className={styles.iconMagicSvg} />
          </div>
        </div>
      </div>
      <div className={styles.popUpNewsActionsBar}>
        <div className={styles.stockTicker}>
          {spots.map((item, index) => (
            <div key={index} className={styles.stockItem}>
              <div className={styles.stockLeft}>
                <span className={styles.stockType}>{item.type.toUpperCase()}</span>
                <span className={styles.stockName}>{item.name}</span>
              </div>
              <div className={styles.stockRight}>
                <b className={styles.stockPrice}>{item.price}</b>
                <span
                  className={`${styles.stockVariation} ${item.variation.includes("-") ? styles.negative : styles.positive
                    }`}
                >
                  {item.variation} {item.variation.includes("-") ? "↓" : "↑"}
                </span>
              </div>
            </div>

          ))}
        </div>

        <div className={styles.newsFilters}>
          {filters.map((filter, index) => (
            <button
              key={index}
              className={styles.filterButton}
              onClick={() => handleRemoveFilter(filter)}
              title={filter === "Para ti" || filter === "Noticias destacadas" ? "" : "Haz clic para eliminar"}
            >
              {filter}
            </button>
          ))}

          {showSearchInput && (
            <form onSubmit={handleSearchSubmit} style={{ display: 'inline-block' }}>
              <input
                type="text"
                value={searchValue}
                onChange={handleSearchInputChange}
                placeholder="Buscar..."
                autoFocus
                style={{
                  padding: '4px 8px',
                  border: '1px solid rgb(221, 221, 221)',
                  borderRadius: '16px',
                  fontSize: '13px',
                  width: '90%',
                  background: '#fff',
                }}
              />
            </form>
          )}

          <button className={styles.coverageButton}>
            Cobertura completa
            <IconMagic />
          </button>
          <button
            className={styles.searchButton}
            onClick={handleSearchClick}
          >
            <IconSearch />
          </button>
        </div>
      </div>


      <div className={styles.popUpNewsContainerItems}>
        {news.map((item, index) => (
          <div key={index} className={styles.popUpNewsContainerItem}>
            <div className={styles.image}>
              <img src={item.image || ImageExample} alt="imagen noticia" className={styles.newsImage} />
              <div
                className={styles.iconOverlay}
                onClick={() => {
                  navigate(`/admin/chat/${selectedAgent?._id || '' }`, {
                    state: {
                      // rowId: `${t('automationQuestion', { type })}`,
                      selectedAgentState: selectedAgent || ''
                    },
                  });
                }}
              >
                <IconMagic />
              </div>
            </div>
            <div className={styles.content}>
              <div className={styles.header}>
                <img src={ImageLogoExample} alt="logo" />
                <span className={styles.sourceEllipsis}>{item.source}</span>
              </div>
              <p className={styles.titleEllipsis}>{item.title}</p>
              <span>{item.time}</span>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default PopUpNews;
